import { Card } from 'Card';
import { Text } from 'Text';
import { BlockLink } from 'BlockLink';
import { useTranslation } from 'react-i18next';
import FrontRoyalSpinner from 'FrontRoyalSpinner';
import { type ComponentProps } from 'react';

type DashboardCardProps = {
    headingText: string;
    handleViewAllPress: () => void;
    isLoading: boolean;
    children: React.ReactNode;
    cardClassNames?: ComponentProps<typeof Card>['classNames'];
};

export function DashboardCard({
    headingText,
    handleViewAllPress,
    isLoading,
    children,
    cardClassNames,
}: DashboardCardProps) {
    const { t } = useTranslation('back_royal');

    return (
        <div>
            <div className="flex items-center justify-between px-3 pb-5">
                <Text as="h2" weight="semibold" color="black" uppercase>
                    {headingText}
                </Text>
                <BlockLink
                    className="text-base"
                    color="slate-grey"
                    anchorIcon="right-arrow"
                    onPress={() => handleViewAllPress()}
                >
                    {t('lessons.stream.featured_events.view_all')}
                </BlockLink>
            </div>

            <Card classNames={{ body: 'p-0', ...cardClassNames }}>
                {isLoading && <FrontRoyalSpinner className="my-8" />}
                {!isLoading && children}
            </Card>
        </div>
    );
}
